import LegalLayout from '@/components/feature/LegalLayout';
import LegalSection from '@/components/feature/LegalSection';

const P = ({ children }: { children: React.ReactNode }) => (
  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">{children}</p>
);

export default function Impressum() {
  return (
    <LegalLayout
      title="Impressum"
      subtitle="Angaben gemäß § 5 TMG sowie Informationen zu Haftung und Urheberrecht."
    >
      <LegalSection index={1} title="Angaben gemäß § 5 TMG">
        <P>Stephanie Wolf</P>
        <P>Am Feldbusch 50</P>
        <P>45889 Gelsenkirchen</P>
      </LegalSection>

      <LegalSection index={2} title="Kontakt">
        <P>Telefon: 0173/1971818</P>
        <P>
          E-Mail:{' '}
          <a
            href="mailto:info@stephanie-wolf.com"
            className="text-primary-600 underline hover:text-primary-700 cursor-pointer break-all"
          >
            info@stephanie-wolf.com
          </a>
        </P>
      </LegalSection>

      <LegalSection index={3} title="Postadresse">
        <P>Stephanie Wolf</P>
        <P>Am Feldbusch 50</P>
        <P>45889 Gelsenkirchen</P>
      </LegalSection>

      <LegalSection index={4} title="Steuerliche Angaben">
        <P>Steuer-Nummer: 319/5655/6430</P>
        <P>Finanzamt: Gelsenkirchen</P>
      </LegalSection>

      <LegalSection index={5} title="Streitschlichtung">
        <P>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
          <a
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-600 underline hover:text-primary-700 cursor-pointer break-all"
          >
            https://ec.europa.eu/consumers/odr
          </a>
          .
        </P>
        <P>Unsere E-Mail-Adresse finden Sie oben im Impressum.</P>
        <P>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </P>
      </LegalSection>

      <LegalSection index={6} title="Haftung für Inhalte">
        <P>
          Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach
          den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
          jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
          überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        </P>
        <P>
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
          allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst
          ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden
          von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
        </P>
      </LegalSection>

      <LegalSection index={7} title="Haftung für Links">
        <P>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
          Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
          Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
          Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf
          mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung
          nicht erkennbar.
        </P>
        <P>
          Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
          Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
          Rechtsverletzungen werden wir derartige Links umgehend entfernen.
        </P>
      </LegalSection>

      <LegalSection index={8} title="Urheberrecht">
        <P>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
          dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
          Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung
          des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den
          privaten, nicht kommerziellen Gebrauch gestattet.
        </P>
        <P>
          Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die
          Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
          gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
          bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden
          wir derartige Inhalte umgehend entfernen.
        </P>
      </LegalSection>

      <LegalSection index={9} title="Hinweise zu Abmahnungen">
        <P>Keine Abmahnung ohne vorherigen Kontakt.</P>
        <P>
          Sollte der Inhalt oder die Aufmachung dieser Seiten fremde Rechte Dritter oder gesetzliche
          Bestimmungen verletzen, so bitten wir um eine entsprechende Nachricht ohne Kostennote. Wir
          garantieren, dass die zu Recht beanstandeten Passagen unverzüglich entfernt werden, ohne
          dass von Ihrer Seite die Einschaltung eines Rechtsbeistandes erforderlich ist. Dennoch von
          Ihnen ohne vorherige Kontaktaufnahme ausgelöste Kosten werden vollumfänglich zurückgewiesen
          und ggf. Gegenklage wegen Verletzung vorgenannter Bestimmungen eingereicht.
        </P>
      </LegalSection>

      <p className="text-xs text-foreground-500">
        Quelle:{' '}
        <a
          href="https://www.e-recht24.de"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary-600 underline hover:text-primary-700 cursor-pointer"
        >
          https://www.e-recht24.de
        </a>
      </p>
    </LegalLayout>
  );
}